import { render, staticRenderFns } from "./ClientsListNewItemButton.vue?vue&type=template&id=e9f718e2&scoped=true&"
import script from "./ClientsListNewItemButton.vue?vue&type=script&lang=js&"
export * from "./ClientsListNewItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f718e2",
  null
  
)

export default component.exports